import React from 'react';
import { Box, Slide } from '@material-ui/core';
import { registerFromInvitationSmsCodeStep as registerLocales } from 'globals/locales/registration';

import {
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
  FsHello,
  FsStep,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import FsSmsCodeForm from 'ui-elements/forms/FsSmsCodeForm';
import { RegisterFromInvitationDataProps } from '../Steps.types';

interface RegisterFromInvitationSmsCodeStepProps
  extends RegisterFromInvitationDataProps {
  onGoNext?: () => void;
  onGoPrev?: () => void;
}

const RegisterFromInvitationSmsCodeStep: React.FC<RegisterFromInvitationSmsCodeStepProps> = ({
  onGoNext,
  onGoPrev,
  formattedPhoneNumber,
}) => {
  return (
    <Slide direction="left" in timeout={300}>
      <FsStep>
        <FsHello>{registerLocales.hello}</FsHello>
        <FsCenterBoxTitle>{registerLocales.title}</FsCenterBoxTitle>
        <FsCenterBoxSubTitle>
          {registerLocales.subTitle} {formattedPhoneNumber}
        </FsCenterBoxSubTitle>
        <FsCenterBoxLine />
        <Box marginTop={3} marginBottom={2}>
          <FsSmsCodeForm onGoPrev={onGoPrev} onGoNext={onGoNext} />
        </Box>
      </FsStep>
    </Slide>
  );
};

export default RegisterFromInvitationSmsCodeStep;
